@if ((dataVisible$ | async)) {
    @if (heeftOndernemingen) {
        <form [formGroup]="formGroupPerOnderneming">
            <div formArrayName="perOnderneming">
                @for (item of winstPerOnderneming.controls; track item; let i = $index) {
                    <div [formGroupName]="i">
                        <div class="row">
                            <div class="col col-1">
                                <p>Winst {{ item.controls.omschrijving.value }}</p>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-3">
                                <snelstart-ui-number-form-control [decimals]="0"
                                                                  [disabledControl]="true"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="bedrag"
                                                                  id="bedrag"
                                                                  prefix="€">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-5"></div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: vrijgestelde winst {{ item.controls.omschrijving.value }}</p>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-3">
                                <snelstart-ui-number-form-control [decimals]="0"
                                                                  [disabledControl]="true"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="vrijgesteldeWinst"
                                                                  id="bedrag"
                                                                  prefix="€ -">
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-5"></div>
                        </div>
                    </div>
                }

            </div>

        </form>



        <form [formGroup]="formGroup">
            @if (winstPerOnderneming.controls.length > 1) {
                <div class="row">
                    <div class="col col-1">
                        <p>Totaal winst uit ondernemingen</p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                [disabledControl]="true"
                                align="right"
                                class="custom-input-150"
                                formControlName="winstAlleOndernemingen"
                                id="winstAlleOndernemingen"
                                prefix="€">
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('zelfstandigenaftrek')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: zelfstandigenaftrek
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="zelfstandigenaftrek"
                                id="zelfstandigenaftrek"
                                placeholder="-"
                                prefix=" € "
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('zelfstandigenaftrekVoorAOWer')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: zelfstandigenaftrek voor AOW-er
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="zelfstandigenaftrekVoorAOWer"
                                id="zelfstandigenaftrekVoorAOWer"
                                prefix=" €"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('startersaftrek')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: startersaftrek
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="startersaftrek"
                                id="startersaftrek"
                                prefix=" € "
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('startersaftrekAO')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: startersaftrek bij arbeidsongeschiktheid
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="startersaftrekAO"
                                id="startersaftrekAO"
                                prefix=" € "
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('meewerkaftrek')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: meewerkaftrek
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="meewerkaftrek"
                                id="meewerkaftrek"
                                prefix=" € "
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('stakingsaftrek')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: stakingsaftrek
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="stakingsaftrek"
                                id="stakingsaftrek"
                                prefix=" € "
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            @if (formGroup.get('senoaftrek')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: aftrek voor speur- en ontwikkelingswerk
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="senoaftrek"
                                id="senoaftrek"
                                prefix=" €"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            <div class="row">
                <div class="col col-1">
                    Totaal ondernemersaftrek
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control [calculate]="berekenTotaalOndermersaftrek()"
                                                      [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="ondernemersaftrek"
                                                      id="oa"
                                                      placeholder="-"
                                                      prefix=" € -"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-5"></div>
            </div>

            @if (formGroup.get('restant')?.value ?? 0 > 0) {
                <div class="row">
                    <div class="col col-1">
                        Af: restant zelfstandigenaftrek voorgaande jaren
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="restant"
                                id="restant"
                                placeholder="-"
                                prefix=" € -"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            }

            <div class="row">
                <div class="col col-1">
                    Mkb-winstvrijstelling
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    @if (formGroup.get('fiscaleWinstMinusOA')?.value ?? 0 >= 0) {
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="mkbWinstvrijstelling"
                                                          id="mkbWinstvrijstelling"
                                                          prefix="€ -"
                        ></snelstart-ui-number-form-control>
                    } @else {
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="mkbWinstvrijstelling"
                                                          id="mkbWinstvrijstelling"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    }
                </div>
                <div class="col-4"></div>
                <div class="col-5"></div>
            </div>

            <div class="row">
                <div class="col col-1">
                    <b>Totaal winst uit onderneming</b>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control [calculate]="berekenBelastbareWinst()"
                                                      [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="belastbareWinst"
                                                      id="belastbareWinst"
                                                      prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-5"></div>
            </div>
        </form>
    } @else {
        <p>Er zijn geen ondernemingen gevonden.</p>
    }
}
